import React from 'react';
import NewsAndAdsContainer from './components/NewsAndAdsContainer';
import ExploreByProperty from './components/ExploreByProperty';
import ExploreByArea from './components/ExploreByArea';
import Taxonomy from './components/Taxonomy';
import SearchArea from './components/SearchArea';
import { CHANNEL_PROP_TYPES } from '../../shared/model/types';
import {
  RECENT_SEARCH_PROP_TYPES,
} from './model/types';

const HomepageComponent = ({
  currentChannel,
  recentSearches,
}) => (
  <div>
    <SearchArea
      currentChannel={currentChannel}
      recentSearches={recentSearches}
    />
    <ExploreByProperty
      currentChannel={currentChannel}
    />
    <ExploreByArea
      currentChannel={currentChannel}
    />
    <NewsAndAdsContainer
      currentChannel={currentChannel}
    />
    <Taxonomy currentChannel={currentChannel} />
  </div>
);

HomepageComponent.propTypes = {
  currentChannel: CHANNEL_PROP_TYPES.isRequired,
  recentSearches: RECENT_SEARCH_PROP_TYPES,
};

export default HomepageComponent;
